<template>
  <div class="animated fadeIn">
    <h1>Laman Utama</h1>
    <b-row>
      <b-col sm="10" md="10">
        <b-card class="col-md-9">
          <table class="table-clean" style="width:100%">
            <tbody>
              <tr>
                <th style="width:23%">NAMA:</th>
                <td>
                  <span
                    id="userName"
                    value="0"
                    style="color:blueviolet; font-weight:bold;"
                  >GREPANON1 - TROLOLOL</span>
                </td>
              </tr>
              <tr>
                <th>NO KAD PENGENALAN:</th>
                <td>
                  <span
                    id="userIcNo"
                    value="0"
                    style="color:blueviolet; font-weight:bold;"
                  >010101011111</span>
                </td>
              </tr>
              <tr>
                <th>EMEL:</th>
                <td>
                  <span
                    id="userEmail"
                    value="0"
                    style="color:blueviolet; font-weight:bold;"
                  >grep_test1@mara.gov</span>
                </td>
              </tr>
            </tbody>
          </table>
        </b-card>
        <b-card class="col-md-9">
          <h1>Permohonan</h1>
          <hr style="border: solid forestgreen" />
          <table class="table-clean" style="width:100%">
            <tbody>
              <tr id="tdProgram">
                <th style="color:black;width:23%">Program:</th>
                <td>
                  <span
                    id="PerPenajaanProgram"
                    value="0"
                    style="color:blueviolet"
                  >GRADUATE EXCELLENCE PROGRAMME (GrEP)</span>
                </td>
              </tr>

              <tr>
                <th style="color:black">Status:</th>
                <td>
                  <span
                    id="PerPenajaanStatus"
                    value="0"
                    style="color:blueviolet"
                  >Butiran Permohonan anda sedang disemak</span>
                  <span id="PerVerifyStatusRed" value="0" style="color:blueviolet"></span>
                  <span id="PerVerifyStatusGreen" value="0" style="color:forestgreen"></span>
                  <span id="PerLinkNotComplete" value="0" style="display:none">
                    <a href="#" name="btnEdit">
                      <font style="text-transform: none;">(Sila klik disini untuk semak)</font>
                    </a>
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
          <b-button
            class="btn-success"
            style="margin-top:10px;margin-bottom:10px"
          >Kemaskini Butiran</b-button>
          <table class="table" style="width:100%">
            <tbody>
              <tr>
                <th style="font-size:13px;" colspan="3">
                  Sila cetak dan lengkapkan dokumen-dokumen berikut:-
                  <br />
                </th>
              </tr>

              <tr>
                <th style="font-size:13px; width:5%;">No.</th>
                <th style="width:23%;font-size:13px">Jenis Dokumen</th>
                <th style="width:23%;font-size:13px">Dokumen</th>
              </tr>

              <tr class>
                <th style="font-size:13px">1</th>
                <th style="width:23%;font-size:13px">Slip Penawaran</th>
                <td>
                  <a id="BtnPrintOfferSlipDaftar" class>Muat Turun</a>
                </td>
              </tr>
              <tr class>
                <th style="font-size:13px">2</th>
                <th style="width:23%;font-size:13px">Surat Tawaran Pinjaman Pelajaran MARA</th>
                <td>
                  <a id="BtnPrintOffer" name="BtnPrintOffer" class>Muat Turun</a>
                </td>
              </tr>
              <tr class>
                <th style="font-size:13px">3</th>
                <th style="width:23%;font-size:13px">Akuan Penerimaan Tawaran Oleh Pelajar</th>
                <td>
                  <a
                    href="/GREP/Resources/Pdf/Akuan Penerimaan Tawaran Oleh Pelajar.pdf"
                    target="_blank"
                  >Muat Turun</a>
                </td>
              </tr>
              <tr class>
                <th style="font-size:13px">4</th>
                <th style="width:23%;font-size:13px">Lampiran A</th>
                <td>
                  <a id="PrintLampiranA" class>Muat Turun</a>
                </td>
              </tr>
              <tr class>
                <th style="font-size:13px">5</th>
                <th style="width:23%;font-size:13px">Lampiran B</th>
                <td>
                  <a href="/GREP/Resources/Pdf/Lampiran B.pdf" target="_blank">Muat Turun</a>
                </td>
              </tr>
              <tr class>
                <th style="font-size:13px">6</th>
                <th style="width:23%;font-size:13px">Lampiran C</th>
                <td>
                  <a href="/GREP/Resources/Pdf/Lampiran C.pdf" target="_blank">Muat Turun</a>
                </td>
              </tr>
              <tr class>
                <th style="font-size:13px">7</th>
                <th style="width:23%;font-size:13px">Dokumen Pinjaman Pelajaran MARA</th>
                <td>
                  <a href="/GREP/Resources/Pdf/BUKU PANDUAN.pdf" target="_blank">Muat Turun</a>
                </td>
              </tr>
              <tr class>
                <th style="font-size:13px">8</th>
                <th style="width:23%;font-size:13px">Surat Iringan</th>
                <td>
                  <a href="/GREP/Resources/Pdf/Surat Iringan.pdf" target="_blank">Muat Turun</a>
                </td>
              </tr>
              <tr class>
                <th style="font-size:13px">9</th>
                <th style="width:23%;font-size:13px">Perjanjian Pinjaman MARA</th>
                <td>
                  <a
                    href="/GREP/Resources/Pdf/Perjanjian Pinjaman MARA.pdf"
                    target="_blank"
                  >Muat Turun</a>
                </td>
              </tr>
              <tr class>
                <th style="font-size:13px">10</th>
                <th style="width:23%;font-size:13px">
                  Borang LPP06 - Payment Instruction
                  <br />(CIMB atau Maybank Sahaja)
                </th>

                <td>
                  <a
                    href="/GREP/Resources/Pdf/Payment Instruction - LPP06.pdf"
                    target="_blank"
                  >Muat Turun</a>
                </td>
              </tr>
              <tr class>
                <th style="font-size:13px">11</th>
                <th style="width:23%;font-size:13px">
                  Borang Medical Examination (MARA Student)
                  <br />(Klinik Kesihatan, Hospital Kerajaan atau Hospital Swasta Sahaja)
                </th>
                <td>
                  <a
                    href="/GREP/Resources/Pdf/Borang Laporan Perubatan.pdf"
                    target="_blank"
                  >Muat Turun</a>
                </td>
              </tr>

              <tr class>
                <th style="font-size:13px">12</th>
                <th style="width:23%;font-size:13px">Borang LPP04</th>
                <td>
                  <a href="/GREP/Resources/Pdf/Borang LPP04.pdf" target="_blank">Muat Turun</a>
                </td>
              </tr>

              <tr class>
                <th style="font-size:13px">13</th>
                <th
                  style="width:23%;font-size:13px"
                >Borang Permohonan (Pastikan Butiran Telah Dikemaskini</th>
                <td>
                  <a id="BtnApplicationFormPost" class>Muat Turun</a>
                </td>
              </tr>
            </tbody>
          </table>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { Switch as cSwitch } from "@coreui/vue";

export default {
  name: "StatusPermohonan",
  components: {
    cSwitch
  },
  data: function() {
    return {
      show: true
    };
  }
};
</script>

<style scoped>
.fade-enter-active {
  transition: all 0.3s ease;
}
.fade-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}
.fade-enter,
.fade-leave-to {
  transform: translateX(10px);
  opacity: 0;
}
</style>





